export const athenaProvider = {
  id: 41,
  prefix: 'Dr',
  providerNpi: null,
  active: true,
  outlookAccessToken: null,
  athenaId: 5,
  isAthenaProvider: false,
  createdAt: '2020-07-06T09:12:48.236Z',
  updatedAt: '2022-02-16T11:14:12.613Z',
  createdBy: null,
  updatedBy: 248,
  organization_providers: [
    {
      id: 1671,
      organizationId: 11,
      providerId: 41,
      athenaDepartmentId: null,
      deletedAt: null,
      createdAt: '2022-02-03T09:31:20.323Z',
      updatedAt: '2022-02-03T09:31:20.323Z',
      createdBy: 1,
      updatedBy: 1,
      organization: {
        id: 11,
        name: 'Arevik Medical Center',
        active: true,
        siteId: 1027,
        defaultProviderId: null,
        accessCode: null,
        allowSelfEnrollment: false,
        address: null,
        city: 'California',
        subdomain: null,
        useReverseProxy: false,
        timezone: 'Pacific/Marquesas',
        authEnabled: false,
        passwordExpiresAfter: null,
        vpnEnabled: false,
        vpnSettings: {
          ipv4: [
            {
              to: '',
              from: '',
            },
          ],
          ipv6: [
            {
              to: '',
              from: '',
            },
          ],
          exclude: [],
        },
        defaultAppointmentTypeId: null,
        isAthenaEnabled: false,
        athenaDefaultDepartmentId: null,
        createdAt: '2020-04-30T15:07:17.624Z',
        updatedAt: '2022-05-12T09:27:13.648Z',
        createdBy: null,
        updatedBy: 1,
        ownerId: 199,
        countryId: 1,
        stateId: 2,
        zipCodeId: 36810,
      },
    },
    {
      id: 1672,
      organizationId: 8,
      providerId: 41,
      athenaDepartmentId: null,
      deletedAt: null,
      createdAt: '2022-02-03T09:31:20.323Z',
      updatedAt: '2022-02-03T09:31:20.323Z',
      createdBy: 1,
      updatedBy: 1,
      organization: {
        id: 8,
        name: 'Armenia Medical Center',
        active: true,
        siteId: 1410,
        defaultProviderId: 41,
        accessCode: 'DEMO2022',
        allowSelfEnrollment: true,
        address: 'qw',
        city: 'California',
        subdomain: null,
        useReverseProxy: false,
        timezone: 'Asia/Kolkata',
        authEnabled: false,
        passwordExpiresAfter: null,
        vpnEnabled: false,
        vpnSettings: {
          ipv4: [
            {
              to: '',
              from: '',
            },
          ],
          ipv6: [
            {
              to: '',
              from: '',
            },
          ],
          exclude: [],
        },
        defaultAppointmentTypeId: 143,
        isAthenaEnabled: true,
        athenaDefaultDepartmentId: 1,
        createdAt: '2020-03-06T09:14:52.528Z',
        updatedAt: '2022-06-10T08:20:32.754Z',
        createdBy: null,
        updatedBy: 4233,
        ownerId: 138,
        countryId: 1,
        stateId: 2,
        zipCodeId: 36324,
      },
    },
  ],
  providers_patients: [
    {
      id: 4853,
      patient: {
        id: 2620,
        user: {
          id: 3337,
          email: 'vikasimone@patient.com',
          user_detail: {
            lastName: 'Simone',
            firstName: 'Vika',
          },
        },
      },
    },
    {
      id: 4758,
      patient: {
        id: 2574,
        user: {
          id: 3287,
          email: 'lunasan@patient.com',
          user_detail: {
            lastName: 'San',
            firstName: 'Luna',
          },
        },
      },
    },
    {
      id: 5828,
      patient: {
        id: 3220,
        user: {
          id: 4031,
          email: 'alice.cooper@patient.com',
          user_detail: {
            lastName: 'Cooper',
            firstName: 'Alice',
          },
        },
      },
    },
    {
      id: 5865,
      patient: {
        id: 2997,
        user: {
          id: 3779,
          email: 'bellasmith@patient.com',
          user_detail: {
            lastName: 'Smith',
            firstName: 'Bella',
          },
        },
      },
    },
    {
      id: 5900,
      patient: {
        id: 1643,
        user: {
          id: 2051,
          email: 'carlwhite@gmail.com',
          user_detail: {
            lastName: 'White',
            firstName: 'Carl',
          },
        },
      },
    },
    {
      id: 5955,
      patient: {
        id: 3219,
        user: {
          id: 4030,
          email: 'domsnup@patient.com',
          user_detail: {
            lastName: 'Snup',
            firstName: 'Dom',
          },
        },
      },
    },
    {
      id: 6580,
      patient: {
        id: 3645,
        user: {
          id: 4610,
          email: 'simahat@patient.com',
          user_detail: {
            lastName: 'hat',
            firstName: 'sima',
          },
        },
      },
    },
    {
      id: 6809,
      patient: {
        id: 3795,
        user: {
          id: 4772,
          email: 'ofeli+08@tidepoollabs.com',
          user_detail: {
            lastName: 'Martini',
            firstName: 'Vika',
          },
        },
      },
    },
    {
      id: 8518,
      patient: {
        id: 3556,
        user: {
          id: 4507,
          email: 'bobmi@patient.com',
          user_detail: {
            lastName: 'Mi',
            firstName: 'Bob',
          },
        },
      },
    },
    {
      id: 8647,
      patient: {
        id: 5417,
        user: {
          id: 6964,
          email: 'shelly@patient.com',
          user_detail: {
            lastName: 'Cooper',
            firstName: 'Sheldon',
          },
        },
      },
    },
    {
      id: 8840,
      patient: {
        id: 305,
        user: {
          id: 547,
          email: 'ann+moris1@tidepoollabs.com',
          user_detail: {
            lastName: 'Moris',
            firstName: 'Anna',
          },
        },
      },
    },
    {
      id: 8978,
      patient: {
        id: 109,
        user: {
          id: 173,
          email: 'brian.may@patient.com',
          user_detail: {
            lastName: 'May',
            firstName: 'Brian',
          },
        },
      },
    },
    {
      id: 9032,
      patient: {
        id: 5733,
        user: {
          id: 7352,
          email: 'lenoard@patient.com',
          user_detail: {
            lastName: 'Hofstadter',
            firstName: 'Lenoard',
          },
        },
      },
    },
    {
      id: 9613,
      patient: {
        id: 110,
        user: {
          id: 174,
          email: 'fred_m@patient.com',
          user_detail: {
            lastName: 'Mercury',
            firstName: 'Freddie',
          },
        },
      },
    },
    {
      id: 10454,
      patient: {
        id: 6976,
        user: {
          id: 8959,
          email: 'elenz@patient.com',
          user_detail: {
            lastName: 'Z',
            firstName: 'Elen',
          },
        },
      },
    },
    {
      id: 10455,
      patient: {
        id: 6977,
        user: {
          id: 8960,
          email: 'royan+testself12@intellihealthcorp.com',
          user_detail: {
            lastName: 'Asla',
            firstName: 'Vels',
          },
        },
      },
    },
    {
      id: 10476,
      patient: {
        id: 6995,
        user: {
          id: 8981,
          email: 'inna.natanel@gmail.com',
          user_detail: {
            lastName: 'Natanel',
            firstName: 'Inna',
          },
        },
      },
    },
    {
      id: 10493,
      patient: {
        id: 7011,
        user: {
          id: 8998,
          email: 'royan+testself13@intellihealthcorp.com',
          user_detail: {
            lastName: 'Woods',
            firstName: 'Sara',
          },
        },
      },
    },
    {
      id: 10593,
      patient: {
        id: 7100,
        user: {
          id: 9108,
          email: 'royan+testself14@intellihealthcorp.com',
          user_detail: {
            lastName: 'Heyman',
            firstName: 'Hark',
          },
        },
      },
    },
    {
      id: 10595,
      patient: {
        id: 7102,
        user: {
          id: 9110,
          email: 'harutyun.mkrtchyan.1995@gmail.com',
          user_detail: {
            lastName: 'Mkrtchyan',
            firstName: 'Harutyun',
          },
        },
      },
    },
    {
      id: 10630,
      patient: {
        id: 7134,
        user: {
          id: 9154,
          email: 'royan+testself21@intellihealthcorp.com',
          user_detail: {
            lastName: 'Quer',
            firstName: 'Hawk',
          },
        },
      },
    },
    {
      id: 10633,
      patient: {
        id: 7137,
        user: {
          id: 9157,
          email: 'royan+testself22@intellihealthcorp.com',
          user_detail: {
            lastName: 'Test1',
            firstName: 'Stag',
          },
        },
      },
    },
    {
      id: 10672,
      patient: {
        id: 7173,
        user: {
          id: 9219,
          email: 'gayathri+selfenroll12@intellihealthcorp.com',
          user_detail: {
            lastName: 'new',
            firstName: 'sam',
          },
        },
      },
    },
    {
      id: 10962,
      patient: {
        id: 7427,
        user: {
          id: 9571,
          email: 'georgelreynolds+26@gmail.com',
          user_detail: {
            lastName: 'Reynolds',
            firstName: 'George',
          },
        },
      },
    },
    {
      id: 11435,
      patient: {
        id: 7857,
        user: {
          id: 10100,
          email: 'george+27@intellihealthcorp.com',
          user_detail: {
            lastName: 'Reynolds',
            firstName: 'George',
          },
        },
      },
    },
    {
      id: 11436,
      patient: {
        id: 7858,
        user: {
          id: 10101,
          email: 'lupeminero+1@gmail.com',
          user_detail: {
            lastName: 'Self Reg1',
            firstName: 'Lupe',
          },
        },
      },
    },
    {
      id: 11443,
      patient: {
        id: 7864,
        user: {
          id: 10112,
          email: 'artyomohanyan+123@tidepoollabs.com',
          user_detail: {
            lastName: 'Teeeesting lastname',
            firstName: 'Teeeesting',
          },
        },
      },
    },
    {
      id: 11444,
      patient: {
        id: 7865,
        user: {
          id: 10113,
          email: 'hhaa@c.com',
          user_detail: {
            lastName: 'Petrosyan',
            firstName: 'Hovo',
          },
        },
      },
    },
    {
      id: 11585,
      patient: {
        id: 7994,
        user: {
          id: 10267,
          email: 'venky+staging@intellihealthcorp.com',
          user_detail: {
            lastName: 'Surya',
            firstName: 'Venky',
          },
        },
      },
    },
    {
      id: 11650,
      patient: {
        id: 8055,
        user: {
          id: 10349,
          email: 'royan+testself26@intellihealthcorp.com',
          user_detail: {
            lastName: 'Carry',
            firstName: 'Denise',
          },
        },
      },
    },
    {
      id: 11651,
      patient: {
        id: 8056,
        user: {
          id: 10350,
          email: 'royan+testself27@intellihealthcorp.com',
          user_detail: {
            lastName: 'Okhama',
            firstName: 'Dada',
          },
        },
      },
    },
    {
      id: 11723,
      patient: {
        id: 8122,
        user: {
          id: 10433,
          email: 'royan+jerma@intellihealthcorp.com',
          user_detail: {
            lastName: 'Hel',
            firstName: 'Jerma',
          },
        },
      },
    },
    {
      id: 11886,
      patient: {
        id: 8279,
        user: {
          id: 10628,
          email: 'royan+testself19@intellihealthcorp.com',
          user_detail: {
            lastName: 'Fazy',
            firstName: 'Gal',
          },
        },
      },
    },
    {
      id: 11974,
      patient: {
        id: 8362,
        user: {
          id: 10731,
          email: 'royan+testself30@intellihealthcorp.com',
          user_detail: {
            lastName: 'Joseph',
            firstName: 'Elle',
          },
        },
      },
    },
    {
      id: 12232,
      patient: {
        id: 8555,
        user: {
          id: 10970,
          email: 'test@address-val.com',
          user_detail: {
            lastName: 'Avagyan',
            firstName: 'Yuri',
          },
        },
      },
    },
  ],
  provider2degrees: [
    {
      id: 3225,
      createdAt: '2022-02-16T11:14:12.623Z',
      updatedAt: '2022-02-16T11:14:12.623Z',
      providerId: 41,
      createdBy: 248,
      updatedBy: 248,
      providerDegreeId: 9,
      provider_degree: {
        id: 9,
        name: 'CNOR',
        description: null,
        createdAt: '2019-09-09T20:47:40.495Z',
        updatedAt: '2019-09-09T20:47:40.495Z',
        createdBy: null,
        updatedBy: null,
      },
    },
    {
      id: 3226,
      createdAt: '2022-02-16T11:14:12.623Z',
      updatedAt: '2022-02-16T11:14:12.623Z',
      providerId: 41,
      createdBy: 248,
      updatedBy: 248,
      providerDegreeId: 81,
      provider_degree: {
        id: 81,
        name: 'CNM',
        description: 'st',
        createdAt: '2020-07-16T00:30:08.112Z',
        updatedAt: '2022-06-10T07:45:50.774Z',
        createdBy: null,
        updatedBy: 1,
      },
    },
    {
      id: 3227,
      createdAt: '2022-02-16T11:14:12.623Z',
      updatedAt: '2022-02-16T11:14:12.623Z',
      providerId: 41,
      createdBy: 248,
      updatedBy: 248,
      providerDegreeId: 6,
      provider_degree: {
        id: 6,
        name: 'CDE',
        description: null,
        createdAt: '2019-09-09T20:47:40.495Z',
        updatedAt: '2019-09-09T20:47:40.495Z',
        createdBy: null,
        updatedBy: null,
      },
    },
  ],
  providers_users: [
    {
      id: 41,
      userId: 248,
      providerId: 41,
      roleId: 11,
      createdAt: '2020-07-06T09:12:48.259Z',
      updatedAt: '2022-02-16T11:14:12.633Z',
      createdBy: null,
      updatedBy: 248,
      user: {
        id: 248,
        email: 'ann+16@tidepoollabs.com',
        timezone: 'America/Cayenne',
        authEnabled: true,
        isTestUser: true,
        user_detail: {
          lastName: 'in Chains',
          firstName: 'Alice',
        },
      },
    },
  ],
  provider_specialities: [
    {
      id: 3170,
      createdAt: '2022-02-16T11:14:12.631Z',
      updatedAt: '2022-02-16T11:14:12.631Z',
      providerId: 41,
      clinicalSpecialityId: 2,
      createdBy: 248,
      updatedBy: 248,
      clinical_speciality: {
        id: 2,
        name: 'Gastroenterology',
        description: null,
        createdAt: '2019-09-09T20:48:56.768Z',
        updatedAt: '2022-01-26T06:13:51.295Z',
        createdBy: null,
        updatedBy: 1,
      },
    },
    {
      id: 3171,
      createdAt: '2022-02-16T11:14:12.631Z',
      updatedAt: '2022-02-16T11:14:12.631Z',
      providerId: 41,
      clinicalSpecialityId: 9,
      createdBy: 248,
      updatedBy: 248,
      clinical_speciality: {
        id: 9,
        name: 'Nephrology',
        description: null,
        createdAt: '2019-09-09T20:48:56.769Z',
        updatedAt: '2019-09-09T20:48:56.769Z',
        createdBy: null,
        updatedBy: null,
      },
    },
  ],
  athenaProviders: [
    {
      id: 3,
      schedulingName: 'ARAS_M',
      name: 'Mohini Aras',
    },
    {
      id: 8,
      schedulingName: 'CIZINSKI_D',
      name: 'Dana Cizinski',
    },
    {
      id: 5,
      schedulingName: 'DICKISON_M',
      name: 'Morgan Dickison',
    },
    {
      id: 1,
      schedulingName: 'IGEL_L',
      name: 'Leon Igel',
    },
    {
      id: 10,
      schedulingName: 'LAKTASH_A',
      name: 'Amy Laktash',
    },
    {
      id: 9,
      schedulingName: 'LESCH_N',
      name: 'Nathan Lesch',
    },
    {
      id: 7,
      schedulingName: 'PALOMINO_M',
      name: 'Martha Palomino',
    },
    {
      id: 4,
      schedulingName: 'REDMOND_I',
      name: 'Ilana Redmond',
    },
    {
      id: 2,
      schedulingName: 'SAUNDERS_K',
      name: 'Katherine Saunders',
    },
    {
      id: 6,
      schedulingName: 'SCHWARTZ_J',
      name: 'Julie Schwartz',
    },
    {
      id: 11,
      schedulingName: 'VANNORTWICK_M',
      name: 'Mary Vannortwick',
    },
  ],
};

export const singleProvider = {
  count: 1,
  rows: [
    {
      id: 92,
      timezone: null,
      firstName: 'Prov',
      lastName: 'Test',
      name: 'Prov Test',
      organizations: ['KCGI Wellness Program'],
      fullName: 'Prov Test',
    },
  ],
};

export const providers = {
  count: 2,
  rows: [
    {
      id: 92,
      'provider.id': 92,
      userId: 2462,
      roleId: 11,
      active: true,
      email: 'test_prov@gmail.com',
      timezone: null,
      firstName: 'Prov',
      lastName: 'Test',
      role: 'Dietitian',
    },
    {
      id: 218,
      'provider.id': 218,
      userId: 2463,
      roleId: 12,
      active: true,
      email: 'test_prov@gmail.com',
      timezone: null,
      firstName: 'Felix',
      lastName: 'Sipa',
      role: 'Admin Assistant',
    },
    {
      count: '1',
      id: 41,
      active: true,
      email: 'ann+16@tidepoollabs.com',
      isTestUser: true,
      timezone: 'America/Cayenne',
      firstName: 'Alice',
      lastName: 'in Chains',
      role: 'Dietitian',
      roleId: 11,
      names: 'Arevik Medical Center, Armenia Medical Center',
    },
  ],
};

export const provider = {
  rows: [
    {
      id: 41,
      timezone: null,
      firstName: 'Prov',
      lastName: 'Test',
      name: 'Prov Test',
      organizations: ['Test Medical Center'],
      fullName: 'Prov Test',
      appointments: {
        isBookingAppointmentsAllowed: true,
      },
    },
  ],
};
export const createProviderData = {
  providerId: null,
  firstName: 'Provider',
  lastName: 'P',
  email: 'test@prov.com',
  roleId: 5,
  clinicalSpecialityIds: [27],
  credentials: [1],
  organizations: [
    {
      id: 8,
      athenaDepartmentId: 1,
    },
  ],
  athenaId: null,
};

export const providerPatientView = {
  id: 41,
  userId: 100,
  email: 'ann+16@tidepoollabs.com',
  timezone: null,
  firstName: 'Alice',
  lastName: 'in Chains',
};
